import axiosInstance from "./axios";
import { errorToast } from "../shared/Toast";

// Feature-scoped API module for system product options (coffee profile
// characteristics: coffee kinds, fruitiness levels, flavour families,
// textures — later roast levels and flavour notes).
// Convention, matching vehicleApi.js: reads return data or a safe default and
// toast on error; mutations return the record or null and let the caller toast success.

const read = async (url, params, fallback, label) => {
  try {
    const res = await axiosInstance.get(url, { params });
    if (res?.data && !res.data.isError) return res.data.data;
    errorToast(res?.data?.message ?? `Error loading ${label}`);
    return fallback;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? `Error loading ${label}`);
    return fallback;
  }
};

const mutate = async (method, url, payload, label, config) => {
  try {
    const res = await axiosInstance[method](url, payload, config);
    if (res?.data && !res.data.isError) return res.data.data;
    errorToast(res?.data?.message ?? `Error ${label}`);
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? `Error ${label}`);
    return null;
  }
};

// Option create/update send multipart (icon upload rides the shared
// ImageController middleware, field name image1 + dataType=productOption).
const toFormData = (payload, imageFile) => {
  const formData = new FormData();
  formData.append("dataType", "productOption");
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) formData.append(key, value);
  });
  if (imageFile) formData.append("image1", imageFile);
  return formData;
};

export const getProductOptions = (params) =>
  read("/api/system-product-options/list", params, [], "product options");

// ---- Purchase-option attributes (Size / Grind — Odoo-mirrored) -------------

export const getProductAttributes = (params) =>
  read("/api/system-product-attributes/list", params, [], "product attributes");

export const createProductAttribute = (payload) =>
  mutate("post", "/api/system-product-attributes/create", payload, "creating attribute");

export const updateProductAttribute = (attributeId, payload) =>
  mutate("put", `/api/system-product-attributes/update/${attributeId}`, payload, "updating attribute");

export const deactivateProductAttribute = (attributeId) =>
  mutate("delete", `/api/system-product-attributes/delete/${attributeId}`, undefined, "deactivating attribute");

export const createAttributeValue = (attributeId, payload) =>
  mutate("post", `/api/system-product-attributes/${attributeId}/values`, payload, "creating value");

export const updateAttributeValue = (valueId, payload) =>
  mutate("put", `/api/system-product-attributes/values/${valueId}`, payload, "updating value");

export const deactivateAttributeValue = (valueId) =>
  mutate("delete", `/api/system-product-attributes/values/${valueId}`, undefined, "deactivating value");

export const createProductOption = (payload, imageFile) =>
  mutate("post", "/api/system-product-options/create", toFormData(payload, imageFile), "creating option", { rawRequest: true });

export const updateProductOption = (optionId, payload, imageFile) =>
  mutate("put", `/api/system-product-options/update/${optionId}`, toFormData(payload, imageFile), "updating option", { rawRequest: true });

export const deactivateProductOption = (optionId) =>
  mutate("delete", `/api/system-product-options/delete/${optionId}`, undefined, "deactivating option");
